import { IClickEventData } from 'types/analytics';
import { DateField, DropdownField, IntField, StringField } from './fields';
import { IFieldTypes } from './additional-info.types';

export const SEND_ADDITIONAL_INFO_ANALYTICS = 'SEND_ADDITIONAL_INFO_ANALYTICS';

export const TEXT_SUB_KEYS = {
    REQUIRED_ERROR: 'invalid-value-field-required',
    NUMBER_MIN_ERROR: 'invalid-value-min-int',
    NUMBER_MAX_ERROR: 'invalid-value-max-int',
    LENGTH_MIN_ERROR: 'invalid-value-length-min',
    LENGTH_MAX_ERROR: 'invalid-value-length-max',
    IS_NOT_NUMBER_ERROR: 'invalid-value-type-number',
    IS_NOT_DATE_ERROR: 'invalid-value-date-format',
    SUBMIT: 'submit-button'
};

export const SUBMIT_FORM_ANALYTICS: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'next',
};

export enum FIELD_VIEW_TYPES {
    INT = 'int',
    DATE =  'date',
    STRING = 'string',
    DROPDOWN = 'dropdown'
}

export const FIELD_VIEW_COMPONENTS: { [key: string]: IFieldTypes } = {
    [FIELD_VIEW_TYPES.INT]: IntField,
    [FIELD_VIEW_TYPES.DATE]: DateField,
    [FIELD_VIEW_TYPES.STRING]: StringField,
    [FIELD_VIEW_TYPES.DROPDOWN]: DropdownField
};
